import {Icon, IconType} from 'src/common/Icon'
import cn from 'classnames'

export type IconTagContainerColor = 'Neon Geen' | 'Moss Black'

type IconTagProps = {
  iconName?: IconType
  label: string
  version?: 'v1' | 'v2'
  iconContainerColor?: IconTagContainerColor
}

export const IconTag = ({iconName, label, version = 'v1', iconContainerColor = 'Neon Geen'}: IconTagProps) => (
  <div
    className={cn('flex items-center gap-2 rounded-full border', {
      'pl-[5px]': iconName && version === 'v1',
      'pl-2.5': !iconName && version === 'v1',
      'border-grey-135 bg-moss-white py-1 pr-2.5': version === 'v1',
      'border-moss-white/[10%] pl-[9px] pr-[11px] py-1.5 bg-moss-white/[20%]': version === 'v2',
    })}
    style={{
      animationDuration: '.7s',
    }}
  >
    {iconName ? (
      <div
        className={cn('flex items-center justify-center rounded-full', {
          'h-[18px] w-[18px] bg-accent-neon': version === 'v1' && iconContainerColor !== 'Moss Black',
          'h-6 w-6 bg-moss-white': version === 'v2',
          'bg-moss-black h-[18px] w-[18px]': iconContainerColor === 'Moss Black',
        })}
      >
        <Icon
          name={iconName}
          className={cn({
            'text-moss-black h-3 w-3': version === 'v2',
            'h-2.5 w-2.5': version === 'v1',
            'text-moss-white': iconContainerColor === 'Moss Black',
          })}
        />
      </div>
    ) : null}
    <span
      className={cn({
        'text-14 font-medium leading-4 tracking-[.28px] text-moss-black': version === 'v1',
        'text-[15px] leading-5 text-moss-white': version === 'v2',
      })}
    >
      {label}
    </span>
  </div>
)
